export default "__VITE_ASSET__B3oBQL15__"